import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Language } from '~/data/languages';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (data: Form) => Promise<void>;
  languages: Language[];
  defaultData: { [key: string]: string } | undefined;
};

type Form = {
  [key: string]: string;
};

export const TranslateDialog = ({
  open,
  onClose,
  onSave,
  languages,
  defaultData,
}: Props) => {
  const { t } = useTranslation();
  const { handleSubmit, control } = useForm<Form>();

  const handleFormSubmit = useMemo(() => {
    return handleSubmit(async (data) => {
      await onSave(data);
    });
  }, [handleSubmit, onSave]);

  return (
    <Dialog open={open} onClose={onClose} sx={{ p: 3 }}>
      <DialogTitle>{t('title_translate')}</DialogTitle>
      <DialogContent>
        {languages.map((lang) => (
          <Controller
            key={lang.fComLanguageCode}
            control={control}
            name={lang.fComLanguageCode}
            defaultValue={defaultData?.[lang.fComLanguageCode] || ''}
            render={({ field }) => {
              return (
                <TextField
                  sx={{ mt: 3 }}
                  label={lang.fComLanguageName}
                  {...field}
                  fullWidth={true}
                />
              );
            }}
          />
        ))}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          {t('close')}
        </Button>
        <Button onClick={handleFormSubmit} variant="contained">
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
